module.exports = __webpack_public_path__ + "static/media/logo-stamp.5d3be0bf.png";